"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M14 9.5a.5.5 0 0 1 .5.5v3.134A1 1 0 0 1 15 14v4a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-4a1 1 0 0 1 .5-.866V10a.5.5 0 0 1 .5-.5v-4c0-.63.247-1.145.735-1.403.457-.241.998-.187 1.457.004.93.387 1.808 1.44 1.808 2.9zm-2.956-4.026c.062.102.17.248.344.396.28.24.757.512 1.555.6-.166-.748-.668-1.251-1.135-1.446-.291-.121-.5-.098-.606-.043-.067.036-.178.13-.199.421zM11 6.83V9.5h2V7.48c-.892-.073-1.539-.334-2-.65"
}), 'LipstickFilled'); //# sourceMappingURL=index.js.map
